import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";

import { AccountService } from './account.service';



/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *hasAnyAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *hasAnyAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
@Directive({
  selector: '[hasAnyAuthority]',
})
export class HasAnyAuthorityDirective implements OnDestroy {
  @Input()
  set hasAnyAuthority(value: string | string[]) {
    const authorities = typeof value === 'string' ? [<string>value] : <string[]>value;

    this.subscriptions.add(
      this.accountService.account$
        .pipe(
          map(account => this.accountService.accountHasAnyAuthority(account, authorities)),
        )
        .subscribe((hasAuthority) => {
          this.viewContainerRef.clear();
          if (hasAuthority) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
          }
        })
    );
  }

  private subscriptions = new Subscription();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private accountService: AccountService
  ) {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
